function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.37,182.27c-4-52.19-39.09-96.13-82.71-122.43a227.5,227.5,0,0,0-141.56-31C174.45,36.44,84.31,79.78,89,159.62c.85,14.44,4.92,28.87,2.8,43.18-3.82,25.8-26.1,44.14-40.95,65.59A125.52,125.52,0,0,0,28.9,346.57c1.82,30.82,17.82,62.92,46.48,74.43s61.16.08,92.11,1.22c50.15,1.86,93.41,36.59,142.84,45.23a142.06,142.06,0,0,0,105.44-23.84c14.1-10,26.56-23,33.08-39.05,16.41-40.33-8.24-86.23-1.75-129.29,4.47-29.61,20.34-55.47,19.61-86.12Q466.62,185.69,466.37,182.27Z",
    style: {
      fill: "#92016D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.37,182.27c-4-52.19-39.09-96.13-82.71-122.43a227.5,227.5,0,0,0-141.56-31C174.45,36.44,84.31,79.78,89,159.62c.85,14.44,4.92,28.87,2.8,43.18-3.82,25.8-26.1,44.14-40.95,65.59A125.52,125.52,0,0,0,28.9,346.57c1.82,30.82,17.82,62.92,46.48,74.43s61.16.08,92.11,1.22c50.15,1.86,93.41,36.59,142.84,45.23a142.06,142.06,0,0,0,105.44-23.84c14.1-10,26.56-23,33.08-39.05,16.41-40.33-8.24-86.23-1.75-129.29,4.47-29.61,20.34-55.47,19.61-86.12Q466.62,185.69,466.37,182.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 464.42,
    y1: 465,
    x2: 477,
    y2: 465,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 465,
    x2: 457.29,
    y2: 465,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 43.04,
    y1: 288.7,
    x2: 56.94,
    y2: 421.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.7,
    y1: 396.45,
    x2: 48.4,
    y2: 389.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.31,391.78a7.13,7.13,0,0,0-2.51-5.34c-1.61-1.45-10.13-5-10.94-2C36,387.67,44.7,394.08,50.31,391.78Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.31,
    y1: 391.78,
    x2: 42.21,
    y2: 386.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.28,
    y1: 411.6,
    x2: 49.98,
    y2: 404.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.89,406.94a7.14,7.14,0,0,0-2.51-5.35c-1.61-1.44-10.13-5-10.94-2C37.56,402.82,46.28,409.23,51.89,406.94Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.89,
    y1: 406.94,
    x2: 43.79,
    y2: 401.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.84,
    y1: 359.47,
    x2: 44.54,
    y2: 352.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.45,354.81a7.14,7.14,0,0,0-2.51-5.35c-1.61-1.45-10.13-5-10.94-2C32.12,350.69,40.84,357.1,46.45,354.81Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.45,
    y1: 354.81,
    x2: 38.35,
    y2: 349.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.42,
    y1: 374.62,
    x2: 46.12,
    y2: 367.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,370a7.12,7.12,0,0,0-2.5-5.35c-1.62-1.44-10.14-5-11-2C33.71,365.85,42.42,372.25,48,370Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.03,
    y1: 369.96,
    x2: 39.93,
    y2: 364.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.27,
    y1: 334.85,
    x2: 41.97,
    y2: 328.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.88,330.19a7.16,7.16,0,0,0-2.5-5.35c-1.62-1.44-10.14-5-11-2C29.55,326.08,38.27,332.48,43.88,330.19Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.88,
    y1: 330.19,
    x2: 35.78,
    y2: 325.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.69,
    y1: 310.13,
    x2: 39.39,
    y2: 303.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3,305.47a7.15,7.15,0,0,0-2.5-5.35c-1.62-1.44-10.14-5-10.95-2C27,301.35,35.69,307.76,41.3,305.47Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.3,
    y1: 305.47,
    x2: 33.2,
    y2: 300.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.64,
    y1: 387.48,
    x2: 58.43,
    y2: 379.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,382a7.16,7.16,0,0,1,1.35-5.75c1.29-1.75,8.88-7,10.29-4.24C70.14,375,62.94,383.1,57,382Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.97,
    y1: 382.01,
    x2: 64.27,
    y2: 375.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.48,
    y1: 347.61,
    x2: 54.27,
    y2: 339.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.81,342.14a7.16,7.16,0,0,1,1.35-5.75c1.29-1.75,8.88-7,10.29-4.25C66,335.15,58.78,343.22,52.81,342.14Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.81,
    y1: 342.14,
    x2: 60.11,
    y2: 335.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.65,
    y1: 330.08,
    x2: 52.44,
    y2: 322.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,324.61a7.16,7.16,0,0,1,1.35-5.75c1.29-1.75,8.88-7,10.29-4.24C64.15,317.63,57,325.7,51,324.61Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.98,
    y1: 324.61,
    x2: 58.28,
    y2: 317.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.97,
    y1: 304.39,
    x2: 49.76,
    y2: 296.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3,298.92a7.16,7.16,0,0,1,1.35-5.75c1.29-1.75,8.88-7,10.29-4.24C61.47,291.94,54.27,300,48.3,298.92Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.3,
    y1: 298.92,
    x2: 55.6,
    y2: 291.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.92,288a7.16,7.16,0,0,1,1.35-5.75c1.29-1.75,8.88-7,10.29-4.25C56.09,281,48.89,289.05,42.92,288Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.92,
    y1: 287.97,
    x2: 50.22,
    y2: 280.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34,288.27a7.13,7.13,0,0,1-5.57-1.95c-1.61-1.46-6.05-9.56-3.15-10.68C37.78,274.43,45.05,282.45,43.34,288.27Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.34,
    y1: 288.27,
    x2: 37.17,
    y2: 280.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.71,
    y1: 307.05,
    x2: 65.89,
    y2: 440.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.94,
    y1: 414.89,
    x2: 64.14,
    y2: 407.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,409.42a7.15,7.15,0,0,0-1.36-5.75c-1.28-1.74-8.88-7-10.29-4.23C52.43,402.45,59.64,410.51,65.61,409.42Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.61,
    y1: 409.42,
    x2: 58.72,
    y2: 402.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.78,
    y1: 377.91,
    x2: 67.98,
    y2: 370.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,372.44a7.15,7.15,0,0,0-1.36-5.75c-1.28-1.74-8.88-7-10.29-4.23C56.27,365.47,63.48,373.53,69.45,372.44Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.45,
    y1: 372.44,
    x2: 62.55,
    y2: 365.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.21,
    y1: 393.06,
    x2: 66.41,
    y2: 385.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.87,387.6a7.11,7.11,0,0,0-1.35-5.75c-1.29-1.75-8.88-7-10.29-4.24C54.7,380.62,61.91,388.69,67.87,387.6Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.87,
    y1: 387.6,
    x2: 60.98,
    y2: 380.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.33,
    y1: 353.29,
    x2: 70.54,
    y2: 345.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,347.83a7.16,7.16,0,0,0-1.35-5.75c-1.29-1.75-8.89-7-10.29-4.24C58.82,340.85,66,348.91,72,347.83Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 347.83,
    x2: 65.11,
    y2: 341.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.9,
    y1: 328.57,
    x2: 73.1,
    y2: 320.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.57,323.1a7.15,7.15,0,0,0-1.36-5.75c-1.28-1.74-8.88-7-10.29-4.23C61.39,316.13,68.6,324.19,74.57,323.1Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.57,
    y1: 323.1,
    x2: 67.67,
    y2: 316.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.75,
    y1: 405.9,
    x2: 76.05,
    y2: 399.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.14,401.23a7.16,7.16,0,0,1,2.5-5.35c1.62-1.44,10.13-5,10.94-2C88.47,397.11,79.75,403.52,74.14,401.23Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.14,
    y1: 401.23,
    x2: 82.72,
    y2: 395.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.89,
    y1: 366.02,
    x2: 80.19,
    y2: 359.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.28,361.35a7.12,7.12,0,0,1,2.5-5.35c1.62-1.44,10.13-5,10.94-2C92.6,357.23,83.89,363.64,78.28,361.35Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.28,
    y1: 361.35,
    x2: 86.86,
    y2: 356.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.71,
    y1: 348.49,
    x2: 82.01,
    y2: 341.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.09,343.83a7.14,7.14,0,0,1,2.51-5.35c1.62-1.45,10.13-5,10.94-2C94.42,339.71,85.71,346.12,80.09,343.83Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.09,
    y1: 343.83,
    x2: 88.67,
    y2: 338.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.37,
    y1: 322.8,
    x2: 84.67,
    y2: 316.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.76,318.14a7.14,7.14,0,0,1,2.51-5.35c1.61-1.45,10.13-5,10.94-2C97.09,314,88.38,320.43,82.76,318.14Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.76,
    y1: 318.14,
    x2: 91.34,
    y2: 312.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.75,306.31A7.14,7.14,0,0,1,82.26,301c1.61-1.45,10.13-5,10.94-2C94.08,302.18,85.36,308.6,79.75,306.31Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 306.31,
    x2: 88.33,
    y2: 300.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1,306.69a7.13,7.13,0,0,1-5-3.05c-1.27-1.76-4-10.61-.88-11.1C77.51,292,83,301.34,80.1,306.69Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1,
    y1: 306.69,
    x2: 75.71,
    y2: 297.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.87,
    y1: 252.8,
    x2: 63.87,
    y2: 421.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 395.96,
    x2: 58.42,
    y2: 388.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,390.87a7.12,7.12,0,0,0-1.94-5.58c-1.46-1.61-9.56-6.05-10.67-3.15C46.3,385.29,54.3,392.57,60.12,390.87Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.12,
    y1: 390.87,
    x2: 52.58,
    y2: 385,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 364.3,
    x2: 58.42,
    y2: 357.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,359.2a7.12,7.12,0,0,0-1.94-5.58c-1.46-1.6-9.56-6.05-10.67-3.15C46.3,353.62,54.3,360.9,60.12,359.2Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.12,
    y1: 359.2,
    x2: 52.58,
    y2: 353.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 327.12,
    x2: 58.42,
    y2: 319.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,322a7.09,7.09,0,0,0-1.94-5.57c-1.46-1.61-9.56-6.06-10.67-3.16C46.3,316.45,54.3,323.72,60.12,322Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.12,
    y1: 322.02,
    x2: 52.58,
    y2: 316.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 302.37,
    x2: 58.42,
    y2: 295.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,297.27a7.09,7.09,0,0,0-1.94-5.57c-1.46-1.61-9.56-6.06-10.67-3.16C46.3,291.7,54.3,299,60.12,297.27Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.12,
    y1: 297.27,
    x2: 52.58,
    y2: 291.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 277.51,
    x2: 58.42,
    y2: 270.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,272.42a7.12,7.12,0,0,0-1.94-5.58c-1.46-1.61-9.56-6-10.67-3.15C46.3,266.84,54.3,274.12,60.12,272.42Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.12,
    y1: 272.42,
    x2: 52.58,
    y2: 266.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.88,
    y1: 405.63,
    x2: 69.46,
    y2: 398.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,400.54A7.12,7.12,0,0,1,69.7,395c1.46-1.61,9.56-6,10.67-3.15C81.58,395,73.58,402.24,67.76,400.54Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.76,
    y1: 400.54,
    x2: 75.74,
    y2: 394.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.88,
    y1: 355.27,
    x2: 69.46,
    y2: 347.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,350.17a7.09,7.09,0,0,1,1.94-5.57c1.46-1.61,9.56-6.06,10.67-3.16C81.58,344.6,73.58,351.87,67.76,350.17Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.76,
    y1: 350.17,
    x2: 75.74,
    y2: 343.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.88,
    y1: 330.41,
    x2: 69.46,
    y2: 323.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,325.32a7.12,7.12,0,0,1,1.94-5.58c1.46-1.61,9.56-6.05,10.67-3.15C81.58,319.74,73.58,327,67.76,325.32Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.76,
    y1: 325.32,
    x2: 75.74,
    y2: 319.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.88,
    y1: 297.56,
    x2: 69.46,
    y2: 290.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,292.46a7.12,7.12,0,0,1,1.94-5.58c1.46-1.6,9.56-6.05,10.67-3.15C81.58,286.88,73.58,294.16,67.76,292.46Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.76,
    y1: 292.46,
    x2: 75.74,
    y2: 286.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.88,
    y1: 271.73,
    x2: 69.46,
    y2: 264.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,266.63a7.12,7.12,0,0,1,1.94-5.58c1.46-1.6,9.56-6.05,10.67-3.15C81.58,261.05,73.58,268.33,67.76,266.63Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.76,
    y1: 266.63,
    x2: 75.74,
    y2: 260.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.54,255.18a7.17,7.17,0,0,1,1.94-5.58c1.46-1.61,9.56-6,10.68-3.16C77.37,249.6,69.37,256.87,63.54,255.18Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.54,
    y1: 255.18,
    x2: 71.53,
    y2: 248.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.93,255.52A7.13,7.13,0,0,1,58.59,253c-1.44-1.62-5-10.14-2-10.95C59.84,241.19,66.23,249.91,63.93,255.52Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.93,
    y1: 255.52,
    x2: 58.62,
    y2: 246.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.8 465 52.95 465 50.72 419.93 73.03 419.93 70.8 465",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.42,31.89a24.35,24.35,0,0,0-3,7.87,25,25,0,0,0-3.26-.22,24.55,24.55,0,0,0-21.53,36.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4,53.79a19.16,19.16,0,0,0-11-3.72,24.54,24.54,0,0,0-43-21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,79.3a24.56,24.56,0,0,0,13.28,8.6h62.11a19.29,19.29,0,0,0,10.2-30.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.21,43.73A24.55,24.55,0,0,0,277,87.9h62.11a19.09,19.09,0,0,0,6.09-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.84,34.74a24.55,24.55,0,0,0-46.65,5,25,25,0,0,0-3.26-.22,24.51,24.51,0,0,0-8.76,1.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,81.87a19.28,19.28,0,0,0-14.27-31.8,24.78,24.78,0,0,0-.08-11.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 208.4,
    x2: 188,
    y2: 106,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239,
    y1: 64,
    x2: 249,
    y2: 64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305,
    y1: 90,
    x2: 305,
    y2: 113.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.97,
    y: 134.02,
    width: 36.06,
    height: 35.96,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.67 153.89 179.04 143.71 179.04 164.06 196.67 153.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.97,
    y: 134.02,
    width: 36.06,
    height: 6.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.98 140.61 174.15 140.61 177.35 134.02 172.18 134.02 168.98 140.61",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.03 136.91 205.03 134.02 201.26 134.02 198.07 140.61 203.24 140.61 205.03 136.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.04 134.02 181.87 134.02 178.68 140.61 183.85 140.61 187.04 134.02",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.74 134.02 191.57 134.02 188.37 140.61 193.54 140.61 196.74 134.02",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.97,
    y: 45.02,
    width: 36.06,
    height: 35.96,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.67 64.89 298.05 54.71 298.05 75.06 315.67 64.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.97,
    y: 45.02,
    width: 36.06,
    height: 6.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.98 51.61 293.15 51.61 296.35 45.02 291.18 45.02 287.98 51.61",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.03 47.91 324.03 45.02 320.26 45.02 317.07 51.61 322.24 51.61 324.03 47.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.04 45.02 300.87 45.02 297.68 51.61 302.85 51.61 306.04 45.02",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.74 45.02 310.57 45.02 307.37 51.61 312.54 51.61 315.74 45.02",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.31,141.26H437.42a11,11,0,0,1,11,11v267a0,0,0,0,1,0,0H247.33a0,0,0,0,1,0,0v-267a11,11,0,0,1,11-11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.42,141.26H304.05v31H448.4V152.23A11,11,0,0,0,437.42,141.26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.42,141.26H258.31a11,11,0,0,0-11,11v8H448.4v-8A11,11,0,0,0,437.42,141.26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.38,
    cy: 151.05,
    r: 3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.71,
    cy: 151.05,
    r: 3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.04,
    cy: 151.05,
    r: 3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 198,
    width: 88.8,
    height: 57.5,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 248.47,
    width: 88.8,
    height: 7.04,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.27 224.57 304.65 214.4 304.65 234.75 322.27 224.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91,252.92H271a1,1,0,0,1,0-2h81a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 270.34,
    width: 88.8,
    height: 57.5,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 320.81,
    width: 88.8,
    height: 7.04,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.27 296.91 304.65 286.74 304.65 307.09 322.27 296.91",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91,325.25H271a1,1,0,0,1,0-2h81a1,1,0,1,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 342.67,
    width: 88.8,
    height: 57.5,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 393.14,
    width: 88.8,
    height: 7.04,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.27 369.25 304.65 359.07 304.65 379.42 322.27 369.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91,397.59H271a1,1,0,0,1,0-2h81a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 203.59,
    width: 55.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 217.59,
    width: 75.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 231.59,
    width: 75.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 278.09,
    width: 55.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 292.09,
    width: 75.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 306.09,
    width: 75.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 352.59,
    width: 55.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 366.59,
    width: 75.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.5,
    y: 380.59,
    width: 75.5,
    height: 6.5,
    style: {
      fill: "#ccc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.39,312.24s3,7.84,3.55,8.77-7.09,4.11-8.77,4.85-4.48-8.77-4.48-8.77Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,233.5s6.25.5,8.25,8.5,4.75,28.75,4.75,33.5,5.25,23.5,8,27.25,3.75,10,1.5,11.75-6.25,7-11.5,2-11.75-21.75-12.25-26.75,1.75-13.75,2-17.25-.25-24.75-2.25-29.5-3-8-3-8S152.33,233,155.83,233.5Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08,333s1.87,3.55,1.5,4.48-2.24.19-3,.38-1.3,2.61,0,3.36,2.24,3.17,4.11,2.61,2.61-5.23,2.61-8.4S178.76,330.34,177.08,333Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,324.56s-1.12,7.84-.75,9.51a54.61,54.61,0,0,1,.94,6.16c0,.75,0,2.43,2.42.94s.37-5,.75-6.35,2.42-1.31,3.17-.19a8.12,8.12,0,0,1,.93,5c-.18,2.06-3.17,4.48-2.42,5.23s2.24.93,3.92-1.12,2.61-6.53,2.24-9.33-1.12-8.21-1.87-10.27a21.07,21.07,0,0,0-1.68-3.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.07,214.55s1.68,12.77-.17,15.3-8.91,3.36-14.29,5.88-4.87,6.05-4.87,10.76,9.41,31.6,8.91,36.48-13.11,18.66-15.3,32.44,10.59,53.63,12.27,60,3.2,10.42,1.35,16.47-5,10.6-5.38,21.19,7.73,38.83,8.23,41.52-3.19,11.09-4.2,15.47,2.86,6.22,6,6.05,8.75-1.35,8.75-3.53-1.85-11.94-1.85-15.64.5-9.58.5-12.1,2.69-26.73,3.36-31.77S137,400,137,400s-.5,25.72-1.17,32.78-2.69,31.1-1.68,33.63,5.21,2,9.75,2.85,3.19,2.53,8.74,3.53,12.77,1.35,11.93-1.34-6.72-6.22-9.75-10.42-6.89-7.57-7.06-8.74a30.7,30.7,0,0,1,.34-6.39c.34-2.36,5-12.61,6.72-19.84s1.18-8.91,1.69-20-2.36-16.82-.51-23.88S164.19,352.06,166,339s2.73-25.15,1.54-30.95c-2.25-11-7.93-18.31-8.94-22.51s3.7-11.6,5.88-22.19-1.84-19.67-4-24.71-9.25-7.23-10.42-7.73-2.19-6.06-2.36-9.59-.16-5.38-.16-5.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.62,470.08c1-4.38,4.71-12.78,4.2-15.47-.21-1.15-1.8-6.94-3.53-14a20.48,20.48,0,0,0,13.16-.52c-.23,2.43-.38,4.21-.38,4.8,0,2.52-.5,8.4-.5,12.1s1.85,13.45,1.85,15.64-5.55,3.36-8.75,3.53S116.61,474.45,117.62,470.08Zm46.9,1.34c-.84-2.69-6.72-6.22-9.75-10.42s-6.89-7.57-7.06-8.74a30.7,30.7,0,0,1,.34-6.39,36.38,36.38,0,0,1,1.77-5.24,17.89,17.89,0,0,1-14.66-.88c-.82,9.89-1.84,24.68-1.06,26.63,1,2.52,5.21,2,9.75,2.85s3.19,2.53,8.74,3.53S165.36,474.11,164.52,471.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.52,471.42c-.84-2.69-6.72-6.22-9.75-10.42s-6.89-7.57-7.06-8.74c0,0-3.63,1.24-4.13,3a33.89,33.89,0,0,1-1.25,3.5,12.82,12.82,0,0,1-7-.75c-.52-.24-1-.46-1.36-.66-.21,4.56-.23,8.15.13,9,1,2.52,5.21,2,9.75,2.85s3.19,2.53,8.74,3.53S165.36,474.11,164.52,471.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,471.43c-8,1.35-15.15-2.27-19.54-4.08a46.4,46.4,0,0,0-11.12-2.52,5.74,5.74,0,0,0,.23,1.55c1,2.52,5.21,2,9.75,2.85s3.19,2.53,8.74,3.53S165.34,474.11,164.53,471.43Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,456.43a9,9,0,0,0-5-1.18,8.75,8.75,0,0,0-3.76.7c-.42,3.49-3.32,10.33-4.2,14.13-1,4.37,2.86,6.22,6,6.05s8.75-1.35,8.75-3.53-1.85-11.94-1.85-15.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,472.6c0-.54-.12-1.53-.28-2.77-1,1.7-3,3.81-7.11,4-7,.29-7-5-7-5h0c-.12.44-.24.87-.33,1.26-1,4.37,2.86,6.22,6,6.05S132.42,474.78,132.42,472.6Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.64,285.49c-1-4.2,3.7-11.6,5.88-22.19s-1.84-19.67-4-24.71-9.25-7.23-10.42-7.73-2.19-6.06-2.36-9.59-.16-5.38-.16-5.38l-16.48-1.34s1.68,12.77-.17,15.3-8.91,3.36-14.29,5.88-4.87,6.05-4.87,10.76,9.41,31.6,8.91,36.48-13.11,18.66-15.3,32.44c-.06.38-.1.78-.14,1.2a118.17,118.17,0,0,0,34.62,6.14c14.64.45,23.54-3.93,28.29-7.47a37.41,37.41,0,0,0-.54-7.28C165.33,297,159.65,289.69,158.64,285.49Z",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.07,230.86c-1.18-.51-2.19-6.06-2.36-9.59s-.16-5.38-.16-5.38l-16.48-1.34s1.68,12.77-.17,15.3c-1.12,1.53-4.19,2.45-7.63,3.5.79,1,6.47,7.75,18.9,5.57a22.75,22.75,0,0,0,12.35-6.11A36.85,36.85,0,0,0,150.07,230.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.71,221.27c-.16-3.53-.16-5.38-.16-5.38l-10.4-.85-.9,2s5,5.23,11.69,6.85C147.83,222.94,147.75,222.06,147.71,221.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.85,216.93l-.24,3.89s-4.44,3.49-17.06-4.81-10.35-35.41,0-44.13,25.64-6.9,30-4.51,7.61.79,9.34,7.59-1.27,10-1.27,10-2.81-3.14-4-3.75-6,.2-7.94,2.86-5.05,20.94-5.61,24.67A27.52,27.52,0,0,1,134.85,216.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.68,176.3s5.24,2.84,8.17,12.53,3,20.6,2.1,23.42a8.91,8.91,0,0,1-5.74,5.69,28.94,28.94,0,0,1-10.91.79c-3-.55-8.45-1.8-8.45-1.8S137.4,176,149.68,176.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86,188.3s-1,3.26,0,5.7,4.91,3.39,4.38,4.42-4.05,3.4-4.05,3.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.47,205.71s-1.46,1.86-7.25.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.27,196.06c.27.82.1,1.61-.37,1.76s-1.07-.38-1.34-1.19-.1-1.61.37-1.76S146,195.25,146.27,196.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,191.24c.26.82.1,1.6-.37,1.76s-1.08-.38-1.34-1.2-.11-1.6.37-1.76S155.71,190.42,156,191.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.51,193.73s.53-2.58,4.11-3.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,187s2.55-1.69,4.14.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.6,243.5l-9.07.2a1.38,1.38,0,0,1-1.4-1.52l2.63-23.69a1.35,1.35,0,0,1,1.33-1.22l9.08-.2a1.36,1.36,0,0,1,1.39,1.52l-2.62,23.69A1.38,1.38,0,0,1,187.6,243.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,247.33s2.18-8.74,2.52-10.93,1.18-3.7,2.52-3.86,2.86-.51,2.86-.51,7.73-4,10.42-4.37,3.7,0,2.86,1-5.38,3.53-6.89,4.37-3.53,2-3.53,2.86,2.69.5,3.36,0,5.55-3.36,7.4-3.2.33,2.86-1.52,3.7-7.06,5.21-7.06,5.21a61.6,61.6,0,0,0,6.22-3c1.52-1,1.68-2.19,2.86-1.85s.84,2.86-.84,4.37-3.19,4.54-5.21,5.88-12.1,7.57-12.1,7.57L167.21,248Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.93,242a24,24,0,0,1-7,4.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.56,232.42a6.83,6.83,0,0,0-2.83,3.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.89 245.65 175.96 255.4 168.39 259.94 162 251.03 167.89 245.65",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44,236.57s-6.9,1.51-7.06,10.42,12.6,40.18,14.29,42,6.38.51,7.9-.34,32.78-20.5,35.8-23.19c0,0,2.69-2.53,2.86-4.38s-4.71-8.06-4.71-8.06-3.36-3-5.88-3.2-26.56,19-26.56,19-7.9-23.37-9.08-24.38",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-99"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "204.74 337.39 200.67 331.61 183.24 356.43 191.81 356.43 191.81 374.16 198.83 374.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "202.55 374.16 209.54 374.16 209.54 356.43 218.11 356.43 206.15 339.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.33 249.1 221.45 233.61 210.57 249.1 215.92 249.1 215.92 260.17 226.98 260.17 226.98 249.1 232.33 249.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "397.21 80.39 403.33 71.67 397.98 71.67 397.98 60.61 386.92 60.61 386.92 71.67 381.57 71.67 392.45 87.17 395.11 83.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "472.06 310.89 479 301 473.65 301 473.65 289.93 469.2 289.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "465.75 289.93 462.58 289.93 462.58 301 457.24 301 468.12 316.49 470.05 313.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "111.9 120.17 115.65 120.17 115.65 109.1 121 109.1 110.12 93.61 99.24 109.1 104.58 109.1 104.58 120.17 109.04 120.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.38 80.75 187.95 55.93 170.51 80.75 179.08 80.75 179.08 98.48 196.81 98.48 196.81 80.75 205.38 80.75",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.85 138.01 305.28 162.83 322.72 138.01 314.15 138.01 314.15 120.28 296.42 120.28 296.42 138.01 287.85 138.01",
    style: {
      fill: "#92016D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1232daa4327e7d463e8aa1fa7ec8c22a.svg";
export { ForwardRef as ReactComponent };